import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import { Table } from "react-bootstrap";
import moment from "moment";
import Row from "react-bootstrap/Row";
// import Image from "react-bootstrap/Image";
// import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
// import { ImageTitleReusableComponent } from "../../../../../reusableComponents/iconSearchReusableComponent/IconReusableComponent";
import SeatingDashboardLeft from "../seatingDashboard/SeatingDashboardLeft";
import DeletePopup from "../../../../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import {
  SeatingStatus,
  // SeatingStatusTwo,
} from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/SeatingStatus";
import TableSizePopup from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
import Filter from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter";
import { SeatingDashboardMobile } from "../../../../../reusableComponents/allTableReusable/seatingDashboardTable/SeatingDashboardMobile";
import {
  SeatingDashboardDesktopTableHead,
  SeatingDashboardTableManagement,
} from "../../../../../reusableComponents/allTableReusable/seatingDashboardTable/SeatingDashboardDesktopTableHead";
import { HistoryDashboardBody } from "../../../../../reusableComponents/allTableReusable/historyDashboardTable/HistoryDashboardBody";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../../store/actions/errorActions";
import {
  sa_whole_vd_seating_diner,
  sa_whole_vd_pending_diner,
  sa_whole_vd_history_diner,
  sa_whole_vd_reservation_diner,
} from "../../../../../../store/actions/SuperAdminVendorDashboardAction/SuperAdminSeatingAction";
import isEmpty from "../../../../../../store/validation/is-Empty";
import { SeatingDashboardRight } from "../seatingDashboard/SeatingDashboardRight";
import SocketContext from "../../../../../../function/SocketContext";
import Media from "react-media";
import { Scan } from "../seatingDashboard/Scan";
import { Image } from "react-bootstrap";
import BasicPagination from "../../../../../Pagination/Pagination";
// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations
// import ChatWindow from "../seatingDashboard/ChatWindow";

const totalRecordsInOnePage = 50;

export class HistoryDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayGrid: false,
      displayDropDown: false,
      currentPagination: 1,
      allHistoryDinersData: [],
      displayMobileSearch: false,
      displaySearch: false,
      selectedPage: 4,
      open: false,
      orderType: false,
      openPax: false,
      openFilterModel: false,
      showStatus: "All",
      showStatusText: "",
      showPax: "All",
      showPaxText: "",
      orderTypeText: "All",
      filterText: "All",
      filterShowText: "All",
      search: "",
      loader: false,
      orderTypeConfirm: "",
      openScan: false,
      chat: false,
      showSearch: false,
    };
    this.chatRef = React.createRef();
  }
  HandleChat = (e) => {
    this.setState({ chat: !this.state.chat });
  };
  openChatWindow = () => {
    this.chatRef.current.openNav();
  };

  componentDidMount() {
    let adminVendorId = JSON.parse(localStorage.getItem("vendorId"));
    let adminSubscriptionId = JSON.parse(
      localStorage.getItem("subscriptionId")
    );
    if (
      adminVendorId !== "" &&
      adminVendorId !== undefined &&
      adminVendorId !== null
    ) {
      this.props.sa_whole_vd_history_diner(
        this.props.auth.user.accessToken,
        adminVendorId,
        adminSubscriptionId,
        () => this.onSuccessPending(),
        () => this.onErrorPending()
      );
      this.props.sa_whole_vd_reservation_diner(
        this.props.auth.user.accessToken,
        adminVendorId,
        adminSubscriptionId,
        () => this.onSuccessPending(),
        () => this.onErrorPending()
      );
      this.props.sa_whole_vd_pending_diner(
        this.props.auth.user.accessToken,
        adminVendorId,
        adminSubscriptionId,
        () => this.onSuccessPending(),
        () => this.onErrorPending()
      );
      this.props.sa_whole_vd_seating_diner(
        this.props.auth.user.accessToken,
        adminVendorId,
        adminSubscriptionId,
        () => this.onSuccessPending(),
        () => this.onErrorPending()
      );
    }
    this.props.socket.service("diner").on("diner_trigger", (data) => {
      if (
        data.diner_status === "CANCELLED" ||
        data.diner_status === "COMPLETED"
      ) {
        this.props.sa_whole_vd_history_diner(
          this.props.auth.user.accessToken,
          adminVendorId,
          adminSubscriptionId,
          () => this.onSuccessPending(),
          () => this.onErrorPending()
        );
      } else {
        let allDiner = this.state.allHistoryDinersData;
        let objIndex = allDiner.findIndex((obj) => obj._id === data._id);
        allDiner[objIndex] = data;
        this.setState({
          allHistoryDinersData: allDiner,
        });
      }
    });

    //this event will trigger on creating a new diner request
    this.props.socket.service("diner").on("diner_creation", (data) => {
      console.log("Diner Reservation", data);
    });
  }

  onSuccessPending = (e) => {
    console.log("On Pending Success");
  };

  onErrorPending = (e) => {
    console.log("On Pending Error");
  };

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.allHistoryDiners) !== nextState.allHistoryDinersData
    ) {
      return {
        allHistoryDinersData: nextProps.allHistoryDiners,
      };
    }
    if (!isEmpty(nextProps.auth.loader) !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
  }

  /****************************************
   * @DESC Open Modal
   ***************************************/
  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };
  onOpenOrderTypeModal = () => {
    this.setState({ orderType: true });
  };
  onCloseOrderTypeModal = () => {
    this.setState({ orderType: false });
  };
  onOpenModalPax = () => {
    this.setState({ openPax: true });
  };
  onCloseModalPax = () => {
    this.setState({ openPax: false });
  };
  openModalScan = () => {
    this.setState({ openScan: true });
  };
  closeModalScan = () => {
    this.setState({ openScan: false });
  };

  onOpenFilterModel = () => {
    this.setState({ openFilterModel: !this.state.openFilterModel });
  };

  /****************************************
   * @DESC Big Button Show Status Handler
   ***************************************/
  filterButtonHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      filterShowText: type,
    });
  };
  filterSaveClick = (e) => {
    this.setState({
      filterText:
        this.state.filterShowText === "" ? "All" : this.state.filterShowText,
      openFilterModel: false,
    });
  };
  resetFilterClick = (e) => {
    this.setState({
      filterText: "All",
      filterShowText: "All",
      openFilterModel: false,
    });
  };

  bigButtonShowStatusHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showStatusText: type,
    });
  };
  selectStatusClick = (e) => {
    this.setState({
      orderTypeText:
        this.state.orderTypeConfirm === ""
          ? "All"
          : this.state.orderTypeConfirm,
      open: false,
    });
  };

  bigButtonShowOrderTypeHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      orderTypeConfirm: type,
      orderType: false,
    });
  };

  bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showPaxText: type,
    });
  };
  selectPaxClick = (e) => {
    console.log("hi");
    this.setState({
      showPax: this.state.showPaxText === "" ? "All" : this.state.showPaxText,
      openPax: false,
    });
  };

  searchButton = (e) => {
    e.preventDefault();
    this.setState({
      displaySearch: true,
    });
  };

  searchButtonClose = (e) => {
    e.preventDefault();
    this.setState({ displaySearch: false });
  };

  searchButtonMobile = (e) => {
    e.preventDefault();
    this.setState({
      displayMobileSearch: true,
    });
  };

  searchButtonMobileClose = (e) => {
    e.preventDefault();
    this.setState({
      displayMobileSearch: false,
    });
  };

  onSearchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
  };

  onChangePagination = (page) => {
    this.setState({
      currentPagination: page,
    });
  };

  /****************************************
   * @DESC Pending Desktop View Components
   ***************************************/
  renderHistoryCardView = () => {
    const {
      allHistoryDinersData,
      showPax,
      showStatus,
      filterText,
      orderTypeText,
      currentPagination,
    } = this.state;
    let filtereddata = [];
    if (
      showPax === "All" &&
      this.state.showStatus === "All" &&
      orderTypeText === "All" &&
      filterText === "All"
    ) {
      filtereddata = allHistoryDinersData;
    } else if (this.state.showPax === "8>") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.adult_count + dinner.kids_count >= 8
      );
    } else if (this.state.showPax === "8") {
      filtereddata = allHistoryDinersData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 7 &&
          dinner.adult_count + dinner.kids_count <= 8
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "6") {
      filtereddata = allHistoryDinersData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 5 &&
          dinner.adult_count + dinner.kids_count <= 6
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "4") {
      filtereddata = allHistoryDinersData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 3 &&
          dinner.adult_count + dinner.kids_count <= 4
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "2") {
      filtereddata = allHistoryDinersData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 0 &&
          dinner.adult_count + dinner.kids_count <= 2
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    }
    if (showStatus === "Walkin") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.isWalkIn === true
      );
    }
    if (showStatus === "Waitlist") {
      filtereddata = allHistoryDinersData.filter((dinner) => {
        if (dinner.service_type === "SEATING" && dinner.isWalkIn === false) {
          return dinner;
        } else {
          return false;
        }
      });
    }
    if (showStatus === "Reservation") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.service_type === "RESERVATION"
      );
    }
    if (orderTypeText === "Seated") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.diner_status === "SEATED"
      );
    }
    if (orderTypeText === "Completed") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.diner_status === "COMPLETED"
      );
    }
    if (orderTypeText === "Rejected") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.diner_status === "REJECTED"
      );
    }
    if (orderTypeText === "Cancelled") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.diner_status === "CANCELLED"
      );
    }
    if (this.state.filterText === "Walk-in") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.isWalkIn === true
      );
    }
    if (this.state.filterText === "Waitlist") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.isWalkIn === false
      );
    }
    if (this.state.filterText === "Reservation") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.service_type === "RESERVATION"
      );
    }

    if (this.state.search) {
      let search = new RegExp(this.state.search, "i");
      filtereddata = allHistoryDinersData.filter((getall) => {
        if (search.test(getall.user_details.name)) {
          return getall;
        } else if (
          search.test(
            getall.user_details.country_code + getall.user_details.mobile_number
          )
        ) {
          return getall;
        } else {
          return false;
        }
      });
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata.map(
        (data, index) =>
          index >= (currentPagination - 1) * totalRecordsInOnePage &&
          index < currentPagination * totalRecordsInOnePage && (
            <React.Fragment key={index}>
              <HistoryDashboardBody
                orderType={true}
                displayCall={true}
                displaySms={true}
                displayNotification={true}
                displayChat={true}
                displayViewDiner={true}
                displayEditDiner={false}
                dinerName={data.user_details.name}
                dinerInfo={data}
                openChatWindow={this.openChatWindow}
                // displayInfo="SUPERADMIN"
                actionPerformBy="ADMIN"
              />
            </React.Fragment>
          )
      );
    } else {
      return null;
    }
  };

  /****************************************
   * @DESC Pending Mobile View Components
   ***************************************/
  renderHistoryAccordian = () => {
    const {
      allHistoryDinersData,
      showPax,
      showStatus,
      currentPagination,
      orderTypeText,
    } = this.state;
    let filtereddata = [];
    if (showPax === "All" && showStatus === "All" && orderTypeText === "All") {
      filtereddata = allHistoryDinersData;
    } else if (this.state.showPax === "8>") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.adult_count + dinner.kids_count >= 8
      );
    } else if (this.state.showPax === "8") {
      filtereddata = allHistoryDinersData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 7 &&
          dinner.adult_count + dinner.kids_count <= 8
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "6") {
      filtereddata = allHistoryDinersData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 5 &&
          dinner.adult_count + dinner.kids_count <= 6
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "4") {
      filtereddata = allHistoryDinersData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 3 &&
          dinner.adult_count + dinner.kids_count <= 4
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "2") {
      filtereddata = allHistoryDinersData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 0 &&
          dinner.adult_count + dinner.kids_count <= 2
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    }
    if (showStatus === "Walkin") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.isWalkIn === true
      );
    }
    if (showStatus === "Waitlist") {
      filtereddata = allHistoryDinersData.filter((dinner) => {
        if (dinner.service_type === "SEATING" && dinner.isWalkIn === false) {
          return dinner;
        } else {
          return false;
        }
      });
    }
    if (showStatus === "Reservation") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.service_type === "RESERVATION"
      );
    }
    if (orderTypeText === "Seated") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.diner_status === "SEATED"
      );
    }
    if (orderTypeText === "Completed") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.diner_status === "COMPLETED"
      );
    }
    if (orderTypeText === "Rejected") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.diner_status === "REJECTED"
      );
    }
    if (orderTypeText === "Cancelled") {
      filtereddata = allHistoryDinersData.filter(
        (dinner) => dinner.diner_status === "CANCELLED"
      );
    }
    if (this.state.search) {
      let search = new RegExp(this.state.search, "i");
      filtereddata = allHistoryDinersData.filter((getall) => {
        if (search.test(getall.user_details.name)) {
          return getall;
        } else if (
          search.test(
            getall.user_details.country_code + getall.user_details.mobile_number
          )
        ) {
          return getall;
        } else {
          return false;
        }
      });
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata.map(
        (data, index) =>
          index >= (currentPagination - 1) * totalRecordsInOnePage &&
          index < currentPagination * totalRecordsInOnePage && (
            <React.Fragment key={index}>
              <SeatingDashboardMobile
                indexKey={index}
                dinnerId={`#${data.diner_id}`}
                dinnerOrderType={"waitlist"}
                dinnerName={data.user_details.name}
                totalCount={data.adult_count + data.kids_count}
                totalAdult={data.adult_count}
                totalKids={data.kids_count}
                totalHighchair={data.high_chair}
                totalHandicapped={data.handicap_chair}
                displayLocation={false}
                date={moment(data.createdAt).format("hh:mm A")}
                time={moment(data.createdAt).format("Do MMM YYYY")}
                displayButton={data}
                seatingPreference={data.seating_preference}
                displayButtonTwo={data}
                displayCall={true}
                displaySms={true}
                displayNotification={true}
                displayViewDiner={true}
                tableNo={
                  data.table_number === null || data.table_number === undefined
                    ? ""
                    : data.table_number
                }
                roomNo={data.room_number}
                specialOcassion={data.occasion}
                status={data.diner_status}
                sendDataDinerProps={data}
              />
            </React.Fragment>
          )
      );
    } else {
      return null;
    }
  };

  render() {
    const { displayGrid, openScan } = this.state;
    if (this.props.auth.loader === true) {
      return <AmealioLoader />;
    } else {
      // const historyImage = require("../../../../../../assets/images/seatingImages/chairWhite.png");
      return (
        <React.Fragment>
          {/* <ChatWindow ref={this.chatRef} /> */}
          <Media query="(min-width: 992px)">
            <div className="container-fluid seating_dashboard_top_new_header">
              <div className="row">
                <div className="col-6">
                  <h4>History Dashboard</h4>
                </div>
                <div className="col-6 text-right">
                  <NavLink
                    to="/superadmin/vendorseating/add-diner"
                    className="btn"
                  >
                    <Image
                        alt="add"
                        title="add"
                        fluid
                        src={require("../../../../../../assets/images/seatingImages/add-button.svg")}
                      />
                    {/* + Add Diner */}
                  </NavLink>
                </div>
              </div>
            </div>
          </Media>
          <Container fluid className="main-seating-dashboard-body">
            <Row>
              <SeatingDashboardLeft selectedPage={this.state.selectedPage} />
            </Row>
            <Media query="(min-width: 992px)">
              <div className="w-100">
                <hr />
              </div>
            </Media>
            <Row>
              <div className="col-12 col-sm-12 col-md-5 col-lg-3 col-xl-3 seating-topbar-search">
                <div className="filter-button">
                  <Filter
                    status={this.state.filterText}
                    onOpenModal={this.onOpenFilterModel}
                    onCloseModal={this.onOpenFilterModel}
                    open={this.state.openFilterModel}
                    seatingStatus={this.state.filterShowText}
                    onClickAll={(e) => this.filterButtonHandler(e, "All")}
                    onClickWalkIn={(e) =>
                      this.filterButtonHandler(e, "Walk-in")
                    }
                    onClickWaitlist={(e) =>
                      this.filterButtonHandler(e, "Waitlist")
                    }
                    onClickReservation={(e) =>
                      this.filterButtonHandler(e, "Reservation")
                    }
                    onStatusClick={this.filterSaveClick}
                    resetFilter={this.resetFilterClick}
                  />
                </div>
                {/* <Media query="(min-width: 992px)">
                  <div className="filter-button-border-left"></div>
                </Media> */}
                <div className="filter-button-search">
                <Image
                    onClick={() =>
                      this.setState({ showSearch: !this.state.showSearch })
                    }
                    alt="filter"
                    title="filter"
                    width="80px"
                    src={require("../../../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                </div>
                {/* <Scan
                  openModalScan={this.openModalScan}
                  onCloseModal={this.closeModalScan}
                  open={openScan}
                  sendData={this.props.onboarding}
                /> */}
              </div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-6 col-xl-8 pt-3" >
                <div className="row">
                <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-5">
                    {/* <SetWaitTime /> */}
                  </div>
                  <div className="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-4" style={{borderRight:"1px solid #E0E0E0"}}>
                    <SeatingStatus
                      status={this.state.orderTypeText}
                      onOpenModal={this.onOpenModal}
                      onCloseModal={this.onCloseModal}
                      open={this.state.open}
                      seatingStatus={this.state.orderTypeConfirm}
                      displayHistory={true}
                      displayNotSeatedButton={true}
                      onClickAll={(e) =>
                        this.bigButtonShowOrderTypeHandler(e, "All")
                      }
                      onClickSeated={(e) =>
                        this.bigButtonShowOrderTypeHandler(e, "Seated")
                      }
                      onClickCancelled={(e) =>
                        this.bigButtonShowOrderTypeHandler(e, "Cancelled")
                      }
                      onClickRejected={(e) =>
                        this.bigButtonShowOrderTypeHandler(e, "Rejected")
                      }
                      onClickCompleted={(e) =>
                        this.bigButtonShowOrderTypeHandler(e, "Completed")
                      }
                      onStatusClick={this.selectStatusClick}
                    />
                  </div>
                  <div className="col-3 col-sm-3 col-md-4 col-lg-4 col-xl-3" style={{borderRight:"1px solid #E0E0E0"}}>
                    <TableSizePopup
                      showPax={this.state.showPax}
                      onOpenModal={this.onOpenModalPax}
                      open={this.state.openPax}
                      onCloseModal={this.onCloseModalPax}
                      table_size={this.state.showPaxText}
                      onClickAll={(e) => this.bigButtonShowPaxHandler(e, "All")}
                      onClickTwo={(e) => this.bigButtonShowPaxHandler(e, "2")}
                      onClickFour={(e) => this.bigButtonShowPaxHandler(e, "4")}
                      onClickSix={(e) => this.bigButtonShowPaxHandler(e, "6")}
                      onClickEight={(e) => this.bigButtonShowPaxHandler(e, "8")}
                      graterThanEight={(e) =>
                        this.bigButtonShowPaxHandler(e, "8>")
                      }
                      selectPaxClick={this.selectPaxClick}
                    />
                  </div>
                  
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-1 right-side-seating justify-content-end d-flex" style={{alignItems:'center'}}>
                <div className="complete_record_image">
                  {/* <DeletePopup
                    display={true}
                    displayPopup="completedRecord"
                    buttonDisplay="completedRecord"
                    buttonText="Complete Record"
                    bigText="Are you sure to Complete All Seated Records ?"
                  />
                  <p className="complete_record_small_text">
                    Mark Seated as Complete
                  </p> */}
                </div>
                <Media query="(min-width: 992px)">
                  <div
                    className="btn-group"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      type="button"
                      className={
                        displayGrid
                          ? "btn grid-button-group"
                          : "btn grid-button-group grid-button-group-active"
                      }
                      onClick={this.onGridViewOpen}
                    >
                      <img
                        src={require("../../../../../../assets/images/ActionImages/image/grid.svg")}
                        className="img-fluid"
                        alt="table"
                        title="table"
                      />
                    </button>
                    <button
                      type="button"
                      className={
                        displayGrid
                          ? "btn grid-button-group grid-button-group-active"
                          : "btn grid-button-group"
                      }
                      onClick={this.onGridViewOpen}
                    >
                      <img
                        src={require("../../../../../../assets/images/ActionImages/image/table.svg")}
                        className="img-fluid"
                        alt="table"
                        title="table"
                      />
                    </button>
                  </div>
                </Media>
              </div>
            </Row>
            {this.state.showSearch && (
          <div className="mb-3">
            <ZoomDiv>
              <>
                <br />
                <Paper component="form" className="enSearch2 d-flex">
                    <IconButton type="submit" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      placeholder="Search"
                      inputProps={{
                        "aria-label": "Search by Name or Phone Number",
                      }}
                      onChange={this.onSearchChange}
                      value={this.state.search}
                    />
                  </Paper>
              </>
            </ZoomDiv>
          </div>
        )}
            {/* <Row>
              {this.state.displayMobileSearch === true ? (
                <div className="col-12 search-input-box-mobile">
                  <div className="position-relative">
                    <Form noValidate>
                      <Form.Group controlId="formGroupSearch">
                        <Form.Control
                          type="search"
                          placeholder="Search by Name or Phone Number"
                          className="search-input-section"
                          onChange={this.onSearchChange}
                          value={this.state.search}
                        />
                      </Form.Group>
                    </Form>
                    <Image
                      alt="Search"
                      title="Search"
                      src={require("../../../../../../assets/images/ActionImages/search.svg")}
                      className="search-icon-image"
                    />
                  </div>
                </div>
              ) : null}
              <div className="col-12 seating-topbar-search seating-topbar-display-none">
                <div>
                  <ImageTitleReusableComponent
                    iconImage={historyImage}
                    imageStyle="img-chair"
                    iconImageAlt="Seating Dashboard"
                    iconImageTitle="Seating Dashboard"
                    iconText="Seating Dashboard"
                  />
                </div>
                <div className="seating-topbar-search-mobile">
                  <div className="mobile-device-position">
                    {/* <DeletePopup
                    display={true}
                    displayPopup="completedRecord"
                    buttonDisplay="completedRecord"
                    buttonText="Complete Record"
                    bigText="Are you sure to Complete All Seated Records ?"
                  /> *
                  </div>
                  <div className="search-input-box">
                    {this.state.displaySearch === false ? (
                      <div>
                        <Image
                          alt="Search"
                          title="Search"
                          src={require("../../../../../../assets/images/ActionImages/search.svg")}
                          className="search-icon-image"
                          onClick={this.searchButton}
                        />
                      </div>
                    ) : (
                      <div className="position-relative">
                        <Form noValidate>
                          <Form.Group controlId="formGroupSearch">
                            <Form.Control
                              type="text"
                              placeholder="Search by Name or Phone Number"
                              className="search-input-section"
                              onChange={this.onSearchChange}
                              value={this.state.search}
                            />
                          </Form.Group>
                        </Form>
                        <i
                          className="fa fa-times close-icon"
                          onClick={this.searchButtonClose}
                        ></i>
                      </div>
                    )}
                  </div>
                  <div className="filter-button">
                    <Filter />
                  </div>
                </div>
              </div>
            </Row> */}
            {/*******************************
             *  @DESC Pending Desktop View
             *******************************/}
            <Media query="(min-width: 992px)">
              <div className="row mt-4">
                <div
                  className={displayGrid === true ? "col-7 p-0" : "col-12 p-0"}
                >
                  <div className="col-12">
                    <div className="seating-dashboard-desktop-table">
                      <Table>
                        <SeatingDashboardDesktopTableHead
                          displayGridProps={displayGrid}
                        />
                      </Table>
                    </div>
                  </div>
                  {displayGrid ? null : (
                    <div className="col-12 today-date-dropdown-seating-dashboard">
                      <div>
                        <h4>Today, {moment().format("Do MMM YYYY")}</h4>
                      </div>
                      <div className="seating-dashboard-today-line">
                        <hr className="line" />
                      </div>
                    </div>
                  )}

                  <div className="col-12 seating-dashboard-body-width">
                    <Table>{this.renderHistoryCardView()}</Table>
                  </div>
                </div>
                <div
                  className={
                    displayGrid === true
                      ? "col-5 seating-right-side-boxcount p-0"
                      : "d-none"
                  }
                >
                  <div className="col-12">
                    <div className="seating-dashboard-desktop-table">
                      <Table>
                        <SeatingDashboardTableManagement />
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </Media>
            {/*******************************
             *  @DESC Pending Mobile View
             *******************************/}
            <Media query="(max-width: 991px)">
              <>
                <div className="row seating-dashboard-table">
                  <div className="col-4 mpr-1">
                    <p className="f12-700 pl-3">Name</p>
                  </div>
                  <div className="col-4 mpl-1 mpr-1">
                    <p className="f12-700">Total PAX</p>
                  </div>
                  <div className="col-4 mpl-1">
                    <p className="f12-700">Timer</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 p-0">
                    <Accordion>{this.renderHistoryAccordian()}</Accordion>
                  </div>
                </div>
              </>
            </Media>
            <div className="p4v2-menu-pagination">
              {/* <Pagination
                onChange={this.onChangePagination}
                current={this.state.currentPagination}
                defaultPageSize={totalRecordsInOnePage}
                total={
                  !isEmpty(this.state.allHistoryDinersData)
                    ? this.state.allHistoryDinersData.length
                    : 0
                }
                showTitle={false}
              /> */}
              <BasicPagination
                    totalRecords={
                      !isEmpty(this.state.allHistoryDinersData)
                        ? this.state.allHistoryDinersData.length
                        : 0
                    }
                    limit={totalRecordsInOnePage}
                    batch={this.state.currentPagination}
                    onBatchChange={this.onChangePagination}
                  />
            </div>
          </Container>
        </React.Fragment>
      );
    }
  }
}

HistoryDashboard.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  sa_whole_vd_pending_diner: PropTypes.func.isRequired,
  sa_whole_vd_seating_diner: PropTypes.func.isRequired,
  sa_whole_vd_reservation_diner: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  allHistoryDiners: state.adminWholeSeating?.vendor_all_history_diner.data,
  allPendingDiners: state.adminWholeSeating?.vendor_all_pending_diner.data,
  onboarding: state.onboarding.restaurantDetails,
  auth: state.auth,
  errors: state.errors.errors,
});

const HistoryDashboardScreen = (props) => (
  <SocketContext.Consumer>
    {(socket) => <HistoryDashboard {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default connect(mapStateToProps, {
  clear_all_errors,
  sa_whole_vd_history_diner,
  sa_whole_vd_reservation_diner,
  sa_whole_vd_pending_diner,
  sa_whole_vd_seating_diner,
})(withRouter(HistoryDashboardScreen));
